import { useCallback, useEffect, useState } from "react";
import { DEFAULT_DEBOUNCE_INTERVAL } from "../appContants";

const useDebounce = (cb, debounceInterval = DEFAULT_DEBOUNCE_INTERVAL) => {
    const [timeoutHandle, setTimeoutHandle] = useState();

    const pauseAndRestart = useCallback(() => {
        timeoutHandle && clearTimeout(timeoutHandle);
        const id = setTimeout(cb, debounceInterval);
        setTimeoutHandle(id);
    }, [cb, timeoutHandle]);

    useEffect(() => {
        // Remove listener on unmount
        return () => timeoutHandle && clearTimeout(timeoutHandle);
    }, []);

    return pauseAndRestart;
};

export default useDebounce;
